<template>
  <q-dialog
    v-model="shown"
    maximized
    transition-show="fade-in"
    transition-hide="fade-out"
  >
    <q-card>
      <div class="row q-ma-sm justify-between">
        <div
          class="col-auto"
          style="min-width: 35px;"
        />
        <div class="col-auto text-h6">
          {{ itemType }} ({{ itemId }}) Version History
        </div>
        <q-btn
          class="col-auto"
          icon="close"
          flat
          round
          dense
          @click="shown = false"
        />
      </div>
      <q-card-section>
        <q-inner-loading
          :showing="versions.loading"
        />
        <div
          v-if="!versions.loading && versions.data.length === 0"
          class="fit text-center"
        >
          {{ itemType }} does not have any historic data.
        </div>
        <div
          v-else-if="!versions.loading"
          class="row q-col-gutter-md column-container"
          style=""
        >
          <div
            class="col-12 col-sm-4"
          >
            <q-list
              bordered
              separator
              :class="$q.screen.lt.sm ? 'stacked-column-33' : 'side-column'"
            >
              <q-item
                v-for="version in versions.data"
                :key="version.id"
                :class="selectedVersion && selectedVersion.id === version.id ? 'bg-white' : 'bg-grey-1'"
                :style="selectedVersion && selectedVersion.id === version.id ? 'border: solid 1px #AAA' : ''"
                clickable
                @click="selectedVersion = version"
              >
                <q-item-section>
                  <div class="row justify-between">
                    <span class="col-auto">
                      <span class="text-subtitle2">{{ $_.startCase(version.event) }}d</span>
                    </span>
                    <span class="col-auto text-caption">
                      {{ $d(version.createdAt, 'medium') }}
                    </span>
                    <span class="col-auto">
                      <span class="text-body"> {{ version.userData ? version.userData.name : 'Automatic' }}</span>
                    </span>
                  </div>
                  <div
                    class="text-caption text-italic"
                  >
                    {{ $_(version.objectChanges).keys().map($_.startCase).value().join(', ') }}
                  </div>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
          <div
            class="col-12 col-sm-8"
          >
            <div
              ref="releaseNotesContainer"
              class="scroll smooth-scroll"
              :class="$q.screen.lt.sm ? 'stacked-column-66' : 'side-column'"
            >
              <q-table
                v-if="selectedVersion"
                v-model:pagination="pagination"
                title="Changes"
                row-key="key"
                :rows="data"
                :columns="columns"
                grid
                :rows-per-page-options="[0]"
                hide-header
                hide-bottom
              >
                <template #top-left>
                  <div class="row q-gutter-x-sm">
                    <div class="q-table__title q-my-xs">
                      Changes
                    </div>
                  </div>
                </template>

                <template #top-right>
                  <div class="row q-gutter-x-sm">
                    <q-btn-toggle
                      v-model="showAll"
                      class="q-my-xs"
                      size="sm"
                      outline
                      toggle-color="primary"
                      :options="[
                        { label: 'All', value: true },
                        { label: 'Changes', value: false }
                      ]"
                    />
                    <q-input
                      v-model="filter"
                      borderless
                      dense
                      debounce="300"
                      placeholder="Search"
                    >
                      <template #append>
                        <q-icon name="search" />
                      </template>
                    </q-input>
                  </div>
                </template>

                <template #item="props">
                  <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
                    <q-card
                      bordered
                      flat
                      :style="{
                        padding: '12px',
                        opacity: props.row.changed ? 1.0 : 0.4
                      }"
                    >
                      <q-card-section
                        class="column q-gutter-y-sm"
                        style="padding: 0;"
                      >
                        <div
                          class="column col"
                        >
                          <span class="q-table__grid-item-value text-bold">
                            {{ props.row.key }}
                          </span>
                        </div>
                        <template v-if="props.row.changed">
                          <div
                            v-if="!showAll"
                            class="column col"
                          >
                            <span
                              class="q-table__grid-item-value text-red text-strike"
                              style="word-break: break-all;"
                            >
                              {{ props.row.oldValue }}
                            </span>
                          </div>
                          <div
                            class="column col"
                          >
                            <span
                              class="q-table__grid-item-value text-green text-bold"
                              style="word-break: break-all;"
                            >
                              {{ props.row.newValue }}
                            </span>
                          </div>
                        </template>
                        <template v-else>
                          <div class="column col">
                            <span
                              class="q-table__grid-item-value"
                              style="word-break: break-all;"
                            >
                              {{ props.row.newValue }}
                            </span>
                          </div>
                        </template>
                      </q-card-section>
                    </q-card>
                  </div>
                </template>
              </q-table>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'VersionsDialog',
  data () {
    return {
      shown: false,
      itemType: null,
      itemId: null,
      selectedVersion: null,
      showAll: false,
      filter: '',
      columns: [
        {
          name: 'key',
          label: 'Field',
          field: 'key'
        },
        {
          name: 'oldValue',
          label: 'Original Value',
          field: 'oldValue'
        },
        {
          name: 'newValue',
          label: 'New Value',
          field: 'newValue'
        }

      ],
      pagination: {
        page: 1,
        rowsPerPage: 0
      }
    }
  },
  models: {
    versions: {
      variables () {
        return {
          itemType: this.itemType,
          itemId: this.itemId,
          skip: !this.itemId
        }
      },
      force: true
    }
  },
  computed: {
    data () {
      if (!this.selectedVersion) return []
      if (this.showAll) {
        return _(Object.keys(this.selectedVersion.newValue)).map(key => {
          if (this.filter.length > 0 && !key.includes(this.filter)) return
          return {
            key: _.startCase(key),
            oldValue: this.selectedVersion.oldValue && this.selectedVersion.oldValue[key] !== null && this.selectedVersion.oldValue[key] !== '' ? this.selectedVersion.oldValue[key] : '-',
            newValue: this.selectedVersion.newValue[key] !== null && this.selectedVersion.newValue[key] !== '' ? this.selectedVersion.newValue[key] : '-',
            changed: !this.selectedVersion.oldValue || this.selectedVersion.oldValue[key] !== this.selectedVersion.newValue[key]
          }
        }).compact().value()
      } else if (this.selectedVersion.objectChanges) {
        return _(Object.keys(this.selectedVersion.objectChanges)).map(key => {
          if (this.filter.length > 0 && !key.includes(this.filter)) return
          return {
            key: _.startCase(key),
            oldValue: this.selectedVersion.oldValue && this.selectedVersion?.oldValue[key] !== null && this.selectedVersion?.oldValue[key] !== '' ? this.selectedVersion?.objectChanges[key][0] : '-',
            newValue: this.selectedVersion.newValue[key] !== null && this.selectedVersion.newValue[key] !== '' ? this.selectedVersion.objectChanges[key][1] : '-',
            changed: true
          }
        }).compact().value()
      } else {
        // Currently this is only the case with non-English translation change logs, as those
        // aren't yet tracked by PaperTrail.
        return []
      }
    }
  },
  watch: {
    'versions.data' () {
      if (this.selectedVersion) return

      this.selectedVersion = this.versions.data[0]
    },
    shown () {
      if (this.shown === true) return

      this.itemType = null
      this.itemId = null
      this.selectedVersion = null
    }
  },
  methods: {
    show (model) {
      this.itemType = model.constructor.name
      this.itemId = model.id
      this.shown = true
    },
    close () {
      this.shown = false
    },
    editModel (model) {
      if (this.$route.params.name === 'users' && this.$route.params.id === '' + this.itemId) {
        this.close()
      } else {
        this.$editModel(model)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .column-container {
    max-height: -webkit-calc(100vh - 70px);
    max-height: -moz-calc(100vh - 70px);
    max-height: calc(100vh - 70px);
    overflow: hidden;
  }
  .stacked-column-33 {
    max-height: -webkit-calc(33vh - 25px);
    max-height: -moz-calc(33vh - 25px);
    max-height: calc(33vh - 25px);
    overflow: auto;
  }
  .stacked-column-66 {
    max-height: -webkit-calc(66vh - 70px);
    max-height: -moz-calc(66vh - 70px);
    max-height: calc(66vh - 70px);
    overflow: auto;
  }
  .side-column {
    max-height: -webkit-calc(100vh - 90px);
    max-height: -moz-calc(100vh - 90px);
    max-height: calc(100vh - 90px);
    overflow: auto;
  }
  .smooth-scroll {
    scroll-behavior: smooth;
  }
</style>
